<template>
  <div class="statistics" :class="{ highlight: highlight }">
    <h2 class="f-24 bold wc-lg" v-if="highlight">
      {{ _.get(this.contentData, "data.list[0].title") }}
    </h2>
    <div class="statistics__inner container grid">
      <div
        class="statistics__column flex column wc-lg a_center"
        v-for="(item, index) in content"
        :key="index"
      >
        <span class="f-48 medium">{{ item.teaser }}</span>
        <span class="f-18 medium statistics__column--ttl" v-if="!highlight">{{
          item.title
        }}</span>
        <span class="f-24 bold statistics__column--ttl" v-else>{{
          item.title
        }}</span>
        <span class="f-18 medium" v-if="highlight">{{ item.option1 }}</span>
        <span class="f-18 medium f-light-purple" v-if="highlight">{{
          item.option2
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],
  computed: {
    content() {
      return _.get(this.contentData, "data.list[0].content.tabs");
    },
    highlight() {
      let conf = _.get(this.contentData, "conf.conf");
      conf = conf.filter(cf => cf == "highlight");
      return conf[0];
    }
  }
};
</script>
